//@ts-nocheck
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import undoable, { groupByActionTypes } from 'redux-undo';

import authReducer from "Store/auth";
import cartBoqSlice from "Store/contentState/cartBoqSlice";
import caseDetailsReducer from "Store/contentState/caseDetailsSlice";
import applicationsSlice from "Store/contentState/configurationArea/PTDAC/applicationsSlice";
// import connectivitySlice from "Store/contentState/configurationArea/PTDAC/connectivitySlice";
import edgeSlice from "Store/contentState/configurationArea/PTDAC/edgeSlice";
import businessSlice from "Store/contentState/configurationArea/businessSlice";
import devicesSlice from "Store/contentState/configurationArea/devicesSlice";
import servicesSlice from "Store/contentState/configurationArea/servicesSlice";
import warrantySlice from "Store/contentState/configurationArea/warrantySlice";
import findCaseSliceReducer from "Store/contentState/findCaseSlice";
import stateMachineSlice from "Store/contentState/stateMachine";
import toolSelectionReducer from "Store/contentState/toolSelection";
import themeReducer from "Store/theme";
import { myLoggingMiddleware } from "Store/middleware";
// import { myLoggingMiddleware } from "./middleware";
import subscriptionReducer from "./contentState/subscriptionSlice";
import marketplaceReducer from './contentState/marketplaceSlice';
import userManagementReducer from './contentState/userManagementSlice';
import paginationSlice from "./contentState/paginationSlice";
import commonSlice from "./contentState/commonSlice";
import merchantReducer from './contentState/merchantSlice';
import radioNetworkCIQSlice from './contentState/radioNetworkCIQSlice';
import configuration_stepperSlice from "./contentState/configuration_stepperSlice";
import marketplaceDynamicSlice from "./contentState/configurationArea/marketplaceDynamicSlice";
import preCiqNetworkSlice from "./contentState/preCiqNetworkSlice";
import networkMasterSlice from "./contentState/networkMasterSlice";
import profitabilitySlice from "../Pages/Profitability/Store/ProfitabilitySlice";
import contractsSlice from '../Pages/Contracts/Store/ContractsSlice'
import dynamicSlice from "Store/contentState/configurationArea/dynamicSlice";
import dashboardSlice from "dot/features/dashboard/store/dashboardSlice";
import cadDiscountsSlice from "dot/Components/Content/configurationArea/Review/ManageCadDiscounts/store/cadDiscountsSlice";
import productMaster from "Store/contentState/productMaster";
import { batchGroupBy } from "dot/Utils";
import onboardingSlice from "Pages/Onboarding/Store/OnboardingSlice";
import installedBaseReducer from "../Pages/Installed-Base/Store/InstalledBaseSlice";
import taskSlice from "./contentState/taskSlice"
import assetsSlice from "./contentState/assetsSlice";
import contractHubReducer from "Pages/Contracts/Components/ContractHub/Store/ContractHubSlice";
import manageAgreementReducer from "Pages/Contracts/Components/ContractHub/Store/ManageAgreementSlice";
// Create an undoable cart reducer using groupByActionTypes
const undoableCartReducer = undoable(cartBoqSlice, {
  filter: groupByActionTypes(['cartBoq/dot_addCartItem', 'cartBoq/dot_updateCartItem']),
  // groupBy:groupByActionTypes(['cartBoq/dot_addCartItem', 'cartBoq/dot_updateCartItem']),
  groupBy: batchGroupBy.init([['cartBoq/dot_addCartItem', 'cartBoq/dot_updateCartItem']]),
  debug: true,
});

const appeRducer = combineReducers({
  //Home//
  authSlice: authReducer,
  findCase: findCaseSliceReducer,
  caseDetails: caseDetailsReducer,
  toolSelection: toolSelectionReducer,
  //Configuration Area//
  business: businessSlice,
  devices: devicesSlice,
  services: servicesSlice,
  warranty: warrantySlice,
  //Configuration Area - PTDAC//
  applications: applicationsSlice,
  // connectivity: connectivitySlice,
  edge: edgeSlice,
  //CART//
  cartBoq: cartBoqSlice,
  //THEME - GLOBAL//
  theme: themeReducer,
  //State-Machine - Global//
  stateMachine: stateMachineSlice,
  subscription: subscriptionReducer,
  marketplace: marketplaceReducer,
  userManagement: userManagementReducer,
  pagination: paginationSlice,
  common: commonSlice,
  merchant: merchantReducer,
  radioNetworkCIQ: radioNetworkCIQSlice,
  config_stepper: configuration_stepperSlice,
  marketplaceDynamic: marketplaceDynamicSlice,
  preCiqNetwork: preCiqNetworkSlice,
  networkMaster: networkMasterSlice,

  // Profitability - Reducer
  profitability: profitabilitySlice,

  // Contracts
  contracts: contractsSlice,

  // Installed Base
  installedBase: installedBaseReducer,

  // DOT specific
  dynamic: dynamicSlice,
  // Dasboard slice
  dashboard: dashboardSlice,
  cadDiscounts: cadDiscountsSlice,
  undoCartBoq: undoableCartReducer,
  productMaster : productMaster,
  task: taskSlice,
  onboarding: onboardingSlice,
  assets: assetsSlice,
  contractHub: contractHubReducer,
  manageAgreement: manageAgreementReducer,
});

// Create a root reducer
const rootReducer = (state, action) => {
  if (action.type === 'RESTORE_STORE') {
    const { payload } = action;

    return {
      ...state,
      ...payload
    }
  }
  return appeRducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(myLoggingMiddleware),
});


//@ts-ignore
window.store = store;
setupListeners(store.dispatch);
export type AppDispatch = typeof store.dispatch; // Here we export the store's dispatch type
export type RootState = ReturnType<typeof store.getState>; // H
